/* eslint-disable @typescript-eslint/no-explicit-any */
// Shared GlitchTip beforeSend scrub for @sentry/react and @sentry/nextjs (client side).
// Copied verbatim from tools/glitchtip/snippets/scrub.browser.ts.
// Copy this file into the app repo (no shared package; repos stay independent).
//
// Browser events never carry a request body/cookies (nothing to send from the
// client), so this scrub reduces user to { id } and strips any `extra` key
// matching the same sensitive-key pattern used server-side.

const SENSITIVE_KEY_PATTERN = /ssn|social|dob|birth|address|phone|email|passport|license/i;
const FILTERED = "[Filtered]";

function scrubUser(user: any): any {
  if (!user || typeof user !== "object") return user;
  if (user.id === undefined) return undefined;
  return { id: user.id };
}

function walkAndFilter(value: any, seen: WeakSet<object> = new WeakSet()): any {
  if (value === null || value === undefined) return value;

  if (Array.isArray(value)) {
    return value.map((item) => walkAndFilter(item, seen));
  }

  if (typeof value === "object") {
    if (seen.has(value)) return value;
    seen.add(value);
    const out: Record<string, any> = {};
    for (const key of Object.keys(value)) {
      if (SENSITIVE_KEY_PATTERN.test(key)) {
        out[key] = FILTERED;
      } else {
        out[key] = walkAndFilter(value[key], seen);
      }
    }
    return out;
  }

  return value;
}

/** beforeSend for browser SDKs: user -> { id }, extra keys matching PII pattern filtered. */
export function beforeSend(event: any): any {
  if (!event) return event;

  if (event.user) {
    const scrubbed = scrubUser(event.user);
    if (scrubbed === undefined) delete event.user;
    else event.user = scrubbed;
  }

  if (event.extra) {
    event.extra = walkAndFilter(event.extra);
  }

  return event;
}
